import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';

@Component({
    selector: 'additional-service-duplicate-dialog',
    templateUrl: './additional-service-duplicate-dialog.component.html',
    styleUrls: ['./additional-service-duplicate-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdditionServiceDuplicateDialogComponent implements OnInit {
  @Input() public disableVerbal: boolean;
  @Input() public disableWritten: boolean;
  public description: string;

  constructor(public activeModal: NgbActiveModal,
    private router: Router            
    ) {
  }

  public ngOnInit(): void {
    if(this.disableWritten && this.disableVerbal){
      this.description = 'Developmental Insight services were previously requested for this employee. Both a report and a meeting have been requested. Please contact our Client Services team at 314-993-8008 or <a href="mailto:testing@ccoleadership.com">testing@ccoleadership.com</a> with questions.';
    }
    else if(this.disableWritten){
      this.description = 'A Development Insight Report was previously requested for this employee. If you would like to add other Development services, please click “Okay” below. Or contact our Client Services team at 314-993-8008 or <a href="mailto:testing@ccoleadership.com">testing@ccoleadership.com</a> with questions.';
    }
    else if(this.disableVerbal){
      this.description = 'A Development Insight Meeting was previously requested for this employee. If you would like to add other Development services, please click “Okay” below. Or contact our Client Services team at 314-993-8008 or <a href="mailto:testing@ccoleadership.com">testing@ccoleadership.com</a> with questions.';
    }
  }

  public goBack() {
    this.router.navigate(['/assessment-requests'])
    .then(() => this.activeModal.close());
  }

  public onDismiss() {
    if(this.disableVerbal && this.disableWritten){
      this.router.navigate(['/assessment-requests'])
      .then(() => this.activeModal.close());
    } else {
      this.activeModal.dismiss();
    }
  }
}
